import type { UpdateAdvisorEntry, UpdateAdvisorResponse } from '../types/updateAdvisor';

export function advisorIsStale(response: UpdateAdvisorResponse, now = Date.now()): boolean {
  return response.stale === true || !Number.isFinite(response.timestamp)
    || now - response.timestamp * 1000 >= 30 * 60 * 1000;
}

export function advisorStatus(entry: UpdateAdvisorEntry): UpdateAdvisorEntry['update_status'] {
  if (entry.error || !entry.latest_version || entry.update_status === 'unknown') return 'unknown';
  if (entry.update_status === 'update_available' && entry.update_available) return 'update_available';
  return entry.update_status === 'up_to_date' && !entry.update_available ? 'up_to_date' : 'unknown';
}

export function advisorPackStatus(entries: UpdateAdvisorEntry[]): UpdateAdvisorEntry['update_status'] {
  if (entries.some(entry => advisorStatus(entry) === 'update_available')) return 'update_available';
  return entries.length && entries.every(entry => advisorStatus(entry) === 'up_to_date') ? 'up_to_date' : 'unknown';
}

export function advisorCheckMessage(error?: string | null): string {
  switch (error) {
    case 'advisory_stale': return 'Release check is overdue';
    case 'installed_versions_unavailable': return 'Installed versions could not be refreshed';
    case 'installed_version_missing': return 'Installed version is missing';
    case 'release_check_pending': return 'Waiting for a release check';
    case 'invalid_modpack_url': return 'Configured source cannot be checked';
    case 'missing_modpack_url': return 'No modpack source configured';
    case 'mod_not_found': return 'Provider project could not be found';
    case 'no_releases': return 'No provider releases found';
    default: return 'Release could not be verified';
  }
}

export function advisorProjectUrl(entry: UpdateAdvisorEntry): string | null {
  if (/^[a-zA-Z0-9_-]+$/.test(entry.latest_release?.project_slug || '')) {
    return `https://www.curseforge.com/minecraft/modpacks/${entry.latest_release!.project_slug}`;
  }
  try {
    const url = new URL(entry.server_download_url);
    return url.protocol === 'https:' && !url.username && !url.password ? url.href : null;
  } catch { return null; }
}
